import { LibConfig, Audience } from 'react-ai-platform-auth'

const origin = window.location.origin
export const refreshTokenCookieDomain = origin?.endsWith('playment.io') ? '.playment.io' : ''

const buildEnvironment: string = process.env.ENV_BUILD_ENVIRONMENT!
export const rootPath =
    buildEnvironment == 'playdock' ? `$ENV_SNAKE_URL` : process.env.ENV_SNAKE_URL
const telusIntOrgId =
    buildEnvironment == 'playdock' ? `$ENV_TELUS_INT_ORG_ID` : process.env.ENV_TELUS_INT_ORG_ID
const apapiUrl = buildEnvironment == 'playdock' ? `$ENV_APAPI_URL` : process.env.ENV_APAPI_URL

export const authConfig: LibConfig = {
    loginUrl: rootPath ?? '/',
    defaultLogoutRedirectUrl: `${rootPath}/logout?redirect=${window.location.origin}`,
    apapiUrl: apapiUrl ?? '',
    aud: Audience.CV_PLATFORM,
    telusInternationalOrgId: telusIntOrgId ?? '',
    passwordResetUrl: `${rootPath}/reset_password`,
    bioAuthUrl: `${rootPath}/biometric_authentication`,
    employeeEmailDomains: ['@telusinternational.com', '@willowtreeapps.com'],
}
